export default __webpack_public_path__ + "79a57e6c6ce27d050bba9e9a26382da1.png";